import { render, staticRenderFns } from "./contentUserAllGroupTurnOnStatus.vue?vue&type=template&id=2c5cc56f&"
import script from "./contentUserAllGroupTurnOnStatus.vue?vue&type=script&lang=js&"
export * from "./contentUserAllGroupTurnOnStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports